import React from 'react'
import { Grid, List, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import Labels from './../../../../common/Labels';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import momentDateAndTime from './../../../../../helpers/momentDateAndTime'
import ImageAvater from '../../../../drive/Components/ImageAvater';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})

class Summary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.getTeam = this.getTeam.bind(this);
    }

    componentWillMount() {
        if (!this.props.teamList || this.props.teamList.length === 0) {
            let payload = {};
            payload.id = this.props.selectedOrganisation.id;
            payload.teamlist = true;
            dispatch.initiatives.getTeamsUnderManager(payload);
        }
    }

    getTeam() {
        const teamObj = this.props.teamList && this.props.teamList.filter((team) => {
            return team.value === this.props.selectedDataById.teamId._id
        })
        return teamObj ? teamObj && teamObj[0] && teamObj[0].text : '';
    }

    render() {

        return (
            <Grid>
                <Grid.Row >
                    <Grid.Column width={11}>
                        <Labels name="Name" text={this.props.selectedDataById && this.props.selectedDataById.name} />

                        <Grid.Row>
                            <Labels name="Description"
                                text={this.props.selectedDataById && this.props.selectedDataById.description}
                                htmlView={true} />
                        </Grid.Row>

                        <Grid.Row>
                            <Labels name="Priority"
                                text={this.props.selectedDataById.priority}
                            />
                        </Grid.Row>

                        <Grid.Row>
                            <Labels
                                name="Category"
                                text={<span >
                                    {this.props.selectedDataById.baseCategory && this.props.selectedDataById.baseCategory.name} &nbsp; <Icon name="chevron right" />
                                    {this.props.selectedDataById.category && this.props.selectedDataById.category.name}&nbsp;<Icon name="chevron right" />
                                    {this.props.selectedDataById.subCategory && this.props.selectedDataById.subCategory.name}
                                </span>}
                            />
                        </Grid.Row>

                        {(this.props.selectedDataById.teamId && this.props.selectedDataById.teamId.toString() !== this.props.selectedOrganisation.id.toString()) ?
                            <Grid.Row >
                                <Labels
                                    name="Initiative Execution"
                                    text="Team Level" />
                                <Labels
                                    name="Selected Team"
                                    text={this.getTeam()} />

                            </Grid.Row>
                            :
                            <Grid.Row >
                                <Grid.Column width={8}>
                                    <Labels
                                        name="Initiative Execution"
                                        text="Workspace Level" />

                                </Grid.Column>
                            </Grid.Row>
                        }

                        <Grid.Row>
                            <Grid.Column >
                                <Labels name="Created On" text={momentDateAndTime(this.props.selectedDataById.actualStartDate)} />
                            </Grid.Column>
                            {
                                this.props.selectedDataById.status === 3 &&
                                <Grid.Column >
                                    <Labels name="Closed On" text={momentDateAndTime(this.props.selectedDataById.actualEndDate)} />
                                </Grid.Column>
                            }
                        </Grid.Row>

                        <Grid.Row>
                            <Labels
                                name="Owner"
                                text={
                                    <List horizontal >
                                        <List.Item>
                                            <ImageAvater user={this.props.initiativeOwnerDetails && this.props.initiativeOwnerDetails} />
                                            <List.Content className='f_12' >
                                                <EllipsisTooltip
                                                    name={this.props.initiativeOwnerDetails && this.props.initiativeOwnerDetails.firstName + ' ' + this.props.initiativeOwnerDetails.lastName}
                                                    line={2}
                                                    style={{ 'lineHeight': '20px' }}
                                                />
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                }
                            />
                        </Grid.Row>
                    </Grid.Column >

                    <Grid.Column width={4}>
                        <Labels name="Image" image={this.props.selectedDataById.picture} />
                        <br />

                        <Labels
                            name="Tags"
                            text={<div>{
                                this.props.selectedDataById.tags &&
                                    this.props.selectedDataById.tags.length !== 0 ?
                                    this.props.selectedDataById.tags.map((tag, i) => {
                                        return <div className="PublishTags" key={i}>{tag}</div>
                                    }) : "NA"}</div>}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid >
        )
    }
}

export default Summary